/**
 *
 * This is a JavaScript function that takes a string as an input and returns a new string that has been normalized and transformed into a "handle" format. The function does the following steps to generate the handle:
 * It checks if the input string is falsy (e.g., undefined, null, '', 0, false), and if so, returns an empty string.
 * Converts the input string to lowercase.
 * Normalizes the string using the "Normalization Form Canonical Decomposition (NFD)" format and removes any diacritics (e.g., accents) from the string using a regular expression.
 * Removes any characters from the list toReplace (i.e., '"', "'", '\\', '(', ')', '[', ']', ',', '.') from the string using a for loop and the replace method.
 * Replaces any sequences of non-word characters (defined as W) with a hyphen - using a regular expression.
 * Removes any hyphens from the end of the string using the replace method.
 * Removes any hyphens from the beginning of the string using the replace method.
 * The result of the function is a string that has been transformed into a handle format, suitable for use in URLs, filenames, or other places where a compact, human-readable identifier is needed.
 *
 * @param str - The string to be transformed into a handle format.
 */
export const handleize = (str: string): string => {
  if (!str) {
    return ''
  }

  let handleizedText = str

  handleizedText = handleizedText.toLowerCase()
  handleizedText = handleizedText
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')

  const toReplace = ['"', "'", '\\', '(', ')', '[', ']', ',', '.']

  // For the old browsers
  for (const element of toReplace) {
    handleizedText = handleizedText.replace(element, '')
  }

  handleizedText = handleizedText.replaceAll(/\W+/g, '-')

  if (handleizedText.endsWith('-')) {
    handleizedText = handleizedText.replace(/-+/, '')
  }

  if (handleizedText.startsWith('-')) {
    handleizedText = handleizedText.replace(/-+/, '')
  }

  return handleizedText
}
